import React, { Component } from 'react';
import { GeckoIcon, GeckoAlert, GeckoFields, ProfileList, Spinner, GeckoBtn} from '../../../../../../components';

import './styles.css';

export default class ActionBar extends Component {
    state = {
        selected: [],
        search: '',
    }

    onChange(e) {
        this.setState({
            search: e.target.value
        }, () => {
            this.props.onSearch(this.state.search);
        });
    }

    renderSearch() {
        return (
            <div className="ActionBar-search-container">
                <div className="ActionBar-search-container-inner">
                    <input type="text" value={this.state.search} placeholder="Filter..." onChange={this.onChange.bind(this)} />
                </div>
            </div>
        )
    }

    renderButtons(buttons) {

        const buttonElements = buttons.map((button, key) => {
            const title = (button.title ? button.title : null);
            return (
                <button 
                    title={title}
                    key={key} 
                    className="ActionBar-actionButton" 
                    onClick={button.handler}>
                        <i className={button.icon} />
                </button>
            );
        });

        return (
            <div className="ActionBar-buttons">
                {buttonElements}
            </div>
        )
    }
   
    render () {
        return (
            <div className="ActionBar">
                {this.renderSearch(this.props.scopes)}
                {this.renderButtons(this.props.buttons)}
            </div>
        );
    }
}